import React, { useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    closeDetailPanel,
    setSelectedUser,
    toggleEditModal,
    setEditedUser,
    openMessageModal
} from '../../../store/usersSlice';
import StatusBadge from '../status_badge/StatusBadge.jsx';
import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import { ReactComponent as ArrowLeftIcon } from '../../icons/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/arrow-right.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as LockIcon } from '../../icons/lock.svg';
import { ReactComponent as UnlockIcon } from '../../icons/unlock.svg';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import peopleIcon from '../../icons/people.png';
import profileAddIcon from '../../icons/profile-add.png';
import profileTickIcon from '../../icons/profile-tick.png';
import magicStarIcon from '../../icons/magic-star.png';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as ArrowUpDownIcon } from '../../icons/arrow-up-down.svg';
import { ReactComponent as CalendarIcon } from '../../icons/calendar.svg';
import { ReactComponent as ClockIcon } from '../../icons/clock.svg';
import Row from '../../list2/row';
import './UserDetailPanel.css';

function UserDetailPanel({ allUsers = [] }) {
    const dispatch = useDispatch();
    const selectedUser = useSelector((state) => state.users.selectedUser);
    const detailPanelOpen = useSelector((state) => state.users.detailPanelOpen);
    const [activeTab, setActiveTab] = useState('basic');

    const statusValue = selectedUser?.status;
    const statusLabel = statusValue === 'blocked'
        ? 'Zablokowany'
        : statusValue === 'pending'
            ? 'Oczekujące'
            : 'Aktywny';
    const statusType = statusValue === 'blocked'
        ? 'inactive'
        : statusValue === 'pending'
            ? 'pending'
            : 'active';

    const nameParts = useMemo(() => {
        const fullName = selectedUser?.fullName || '';
        const parts = fullName.split(' ');
        const firstName = parts[0] || '-';
        const lastName = parts.slice(1).join(' ') || '-';
        return { firstName, lastName };
    }, [selectedUser?.fullName]);

    const currentIndex = selectedUser
        ? allUsers.findIndex((u) => u.id === selectedUser.id)
        : -1;
    const totalCount = allUsers.length;

    const handlePrevious = useCallback(() => {
        if (currentIndex > 0) {
            dispatch(setSelectedUser(allUsers[currentIndex - 1]));
        }
    }, [currentIndex, allUsers, dispatch]);

    const handleNext = useCallback(() => {
        if (currentIndex >= 0 && currentIndex < allUsers.length - 1) {
            dispatch(setSelectedUser(allUsers[currentIndex + 1]));
        }
    }, [currentIndex, allUsers, dispatch]);

    const handleEdit = useCallback(() => {
        if (selectedUser) {
            dispatch(setEditedUser(selectedUser));
            dispatch(toggleEditModal());
        }
    }, [selectedUser, dispatch]);

    const [packagesSearch, setPackagesSearch] = useState('');
    const [packagesSort, setPackagesSort] = useState({ field: 'id', direction: 'asc' });
    const [hoveredPackageId, setHoveredPackageId] = useState(null);
    const [expandedPackageId, setExpandedPackageId] = useState(null);
    const [selectedPackageForDetails, setSelectedPackageForDetails] = useState(null);
    const [expandedReportId, setExpandedReportId] = useState(null);

    const packages = [
        {
            id: 1,
            name: "Festiwal '25",
            founder: 'Adam234',
            memberCount: 5,
            description: 'Uzupełnij kilka słów o swojej paczce.',
            event: {
                name: 'Nowy Festiwal Muzyczny',
                location: 'Spodek, Katowice',
                date: '2026-08-15',
                time: '16:00',
            },
            users: [
                { id: 1, username: 'Adam234', isFounder: true },
                { id: 2, username: 'Kasia_M' },
                { id: 3, username: 'PiotrK' },
                { id: 4, username: 'MartaW' },
                { id: 5, username: 'TomekB' },
            ],
        },
        {
            id: 2,
            name: 'Weekend z muzyką',
            founder: 'Kasia_M',
            memberCount: 8,
            description: 'Paczka na koncert weekendowy.',
            event: {
                name: 'Nowy Festiwal Muzyczny',
                location: 'Spodek, Katowice',
                date: '2026-08-15',
                time: '16:00',
            },
            users: [
                { id: 1, username: 'Kasia_M', isFounder: true },
                { id: 2, username: 'AniaS' },
                { id: 3, username: 'Olek' },
            ],
        },
    ];

    const filteredPackages = packages.filter((pkg) => (
        pkg.name.toLowerCase().includes(packagesSearch.toLowerCase()) ||
        pkg.founder.toLowerCase().includes(packagesSearch.toLowerCase())
    ));

    const sortedPackages = [...filteredPackages].sort((a, b) => {
        const field = packagesSort.field;
        const direction = packagesSort.direction === 'asc' ? 1 : -1;
        if (typeof a[field] === 'number' && typeof b[field] === 'number') {
            return (a[field] - b[field]) * direction;
        }
        return String(a[field]).localeCompare(String(b[field])) * direction;
    });

    const handlePackageSort = (field) => {
        setPackagesSort((prev) => {
            if (prev.field === field) {
                return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { field, direction: 'asc' };
        });
    };

    const reportsData = [
        {
            id: 1,
            date: '2024-10-07',
            reporter: `Nick (${selectedUser?.fullName || '-'})`,
            packName: 'Festiwal,25',
            reason: 'Niestosowne treści',
            reportedMessage: {
                author: 'Kamila',
                content: 'Nie mogę się już doczekać! Mam nadzieję, że ten występ będzie tak samo dobry jak poprzedni.',
            },
            reporterMessage: 'Proszę o usunięcie tego użytkownika bo zachęca do spamowania.',
        },
        {
            id: 2,
            date: '2024-10-07',
            reporter: `${selectedUser?.nickname || 'Angie5'} (${selectedUser?.fullName || '-'})`,
            packName: 'Tylko kobiety',
            reason: 'Inny powód',
            reportedMessage: {
                author: 'Agata',
                content: 'Nie zapomnijcie o biletach, bez nich nie wejdziemy na koncert.',
            },
            reporterMessage: 'To wiadomość jest nie na temat i przeszkadza w dyskusji.',
        },
    ];

    const reportsHeaders = [
        <div key="reports-date-header" className="table-columns-headers">
            <div>Data</div>
            <ArrowUpDownIcon />
        </div>,
        <div key="reports-from-header">Zgłoszenie od</div>,
        <div key="reports-pack-header">Nazwa paczki</div>,
        <div key="reports-reason-header">Powód</div>,
        <div key="reports-actions-header">Akcje</div>,
    ];

    const reportsColumnWidths = ['120px', '1.2fr', '1fr', '1fr', '180px'];
    const renderReportRow = (report) => ([
        report.date,
        report.reporter,
        report.packName,
        report.reason,
        <div key={`reports-actions-${report.id}`} className="actions-cell users-actions">
            <button className="report-reject-btn" type="button">
                Odrzuć
            </button>
            <button
                className="open-details-btn report-toggle-btn"
                type="button"
                aria-label="Szczegoly"
                aria-expanded={expandedReportId === report.id}
                aria-controls={`report-details-${report.id}`}
                onClick={() => setExpandedReportId(expandedReportId === report.id ? null : report.id)}
            >
                <ArrowRightIcon className="arrow-right-icon" />
            </button>
        </div>,
    ]);

    if (!detailPanelOpen || !selectedUser) return null;

    return (
        <>
            <div className="user-detail-backdrop" onClick={() => dispatch(closeDetailPanel())} />
            <div className="user-detail-panel">
                <div className="user-detail-header">
                    <div className="header-left">
                        <button
                            className="close-btn"
                            onClick={() => dispatch(closeDetailPanel())}
                            aria-label="Zamknij"
                            type="button"
                        >
                            <CloseIcon />
                        </button>
                        <div className="navigation-arrows">
                            <button
                                className="nav-arrow-btn"
                                onClick={handlePrevious}
                                disabled={currentIndex <= 0}
                                title="Poprzedni"
                                type="button"
                            >
                                <ArrowLeftIcon className="nav-arrow-icon" />
                            </button>
                            <button
                                className="nav-arrow-btn"
                                onClick={handleNext}
                                disabled={currentIndex >= totalCount - 1}
                                title="Następny"
                                type="button"
                            >
                                <ArrowRightIcon className="nav-arrow-icon" />
                            </button>
                        </div>
                        <span className="results-counter">
                            {currentIndex + 1} z {totalCount} wyników
                        </span>
                    </div>
                    <div className="header-right">
                        <span className="registration-date">
                            Data rejestracji: {selectedUser.registrationDate}
                        </span>
                    </div>
                </div>

                <div className="user-detail-content">
                    <div className="user-title-row">
                        <div className="user-title-left">
                            <span className="user-id-line">
                                (ID {selectedUser.id}) Ostatnie logowanie: {selectedUser.lastLogin || '-'}
                            </span>
                            <div className="user-name-row">
                                <h2 className="user-name">
                                    {selectedUser.nickname}
                                </h2>
                                <span className="user-fullname">
                                    ({selectedUser.fullName})
                                </span>
                                <StatusBadge status={statusType} label={statusLabel} />
                            </div>
                        </div>
                        <button
                            className="message-btn"
                            type="button"
                            onClick={() => dispatch(openMessageModal(selectedUser))}
                        >
                            Wyślij wiadomość
                        </button>
                    </div>

                    <div className="detail-tabs-nav">
                        <div className="tabs-container">
                            <button
                                className={`tab-btn ${activeTab === 'basic' ? 'active' : ''}`}
                                onClick={() => setActiveTab('basic')}
                                type="button"
                            >
                                Dane podstawowe
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'packs' ? 'active' : ''}`}
                                onClick={() => setActiveTab('packs')}
                                type="button"
                            >
                                Utworzone paczki
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'stats' ? 'active' : ''}`}
                                onClick={() => setActiveTab('stats')}
                                type="button"
                            >
                                Statystyki
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 'reports' ? 'active' : ''}`}
                                onClick={() => setActiveTab('reports')}
                                type="button"
                            >
                                Zgłoszone zablokowania
                                <span className="tab-badge">{reportsData.length}</span>
                            </button>
                        </div>
                    </div>

                    {activeTab === 'basic' && (
                        <div className="tab-content basic-data">
                            <div className="data-section">
                                <div className="data-row two-column">
                                    <div className="data-row-inner">
                                        <div className="data-label">ID</div>
                                        <div className="data-value">{selectedUser.id}</div>
                                    </div>
                                    <div className="data-row-inner">
                                        <div className="data-label">Nick</div>
                                        <div className="data-value">{selectedUser.nickname}</div>
                                    </div>
                                </div>
                                <div className="data-row two-column">
                                    <div className="data-row-inner">
                                        <div className="data-label">Imię</div>
                                        <div className="data-value">{nameParts.firstName}</div>
                                    </div>
                                    <div className="data-row-inner">
                                        <div className="data-label">Nazwisko</div>
                                        <div className="data-value">{nameParts.lastName}</div>
                                    </div>
                                </div>
                                <div className="data-row">
                                    <div className="data-row-inner">
                                        <div className="data-label">Płeć</div>
                                        <div className="data-value">{selectedUser.gender}</div>
                                    </div>
                                </div>
                                <div className="data-row">
                                    <div className="data-row-inner">
                                        <div className="data-label">Numer telefonu</div>
                                        <div className="data-value">{selectedUser.phone}</div>
                                    </div>
                                </div>
                                <div className="data-row contact-row">
                                    <div className="data-row-inner">
                                        <div className="data-label">Adres e-mail</div>
                                        <div className="data-value">{selectedUser.email}</div>
                                    </div>
                                    <button className="reset-btn" type="button">
                                        Wiadomość z resetem hasła
                                    </button>
                                </div>
                                <div className="data-row">
                                    <div className="data-row-inner">
                                        <div className="data-label">Opis</div>
                                        <div className="data-value">
                                            {selectedUser.description || 'Opis profilu...'}
                                        </div>
                                    </div>
                                </div>
                                <div className="data-row profile-row">
                                    <div className="data-row-inner">
                                        <div className="data-label">Zdjęcie profilowe</div>
                                        <div className="profile-placeholder" />
                                    </div>
                                    <button className="report-btn" type="button">
                                        Zgłoś naruszenie i usuń
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'packs' && (
                        <div className="tab-content packs-tab">
                            <div className="detail-tab-packs">
                                <div className="packs-header">
                                    <span className="packs-count">Liczba paczek: {packages.length}</span>
                                    <div className="packs-search">
                                        <SearchIcon className="packs-search-icon" />
                                        <input
                                            type="text"
                                            placeholder="Szukaj"
                                            value={packagesSearch}
                                            onChange={(e) => setPackagesSearch(e.target.value)}
                                            className="packs-search-input"
                                        />
                                    </div>
                                </div>

                                <div className="packs-table-container">
                                    <div className="packs-table">
                                        <div className="packs-table-header">
                                            <div
                                                className="packs-th packs-th-id"
                                                onClick={() => handlePackageSort('id')}
                                            >
                                                <span>ID</span>
                                                <ArrowUpDownIcon className={`packs-sort-icon ${packagesSort.field === 'id' ? 'active' : ''}`} />
                                            </div>
                                            <div
                                                className="packs-th packs-th-name"
                                                onClick={() => handlePackageSort('name')}
                                            >
                                                <span>Nazwa paczki</span>
                                                <ArrowUpDownIcon className={`packs-sort-icon ${packagesSort.field === 'name' ? 'active' : ''}`} />
                                            </div>
                                            <div
                                                className="packs-th packs-th-founder"
                                                onClick={() => handlePackageSort('founder')}
                                            >
                                                <span>Założyciel</span>
                                                <ArrowUpDownIcon className={`packs-sort-icon ${packagesSort.field === 'founder' ? 'active' : ''}`} />
                                            </div>
                                            <div
                                                className="packs-th packs-th-members"
                                                onClick={() => handlePackageSort('memberCount')}
                                            >
                                                <span>Liczba osób</span>
                                                <ArrowUpDownIcon className={`packs-sort-icon ${packagesSort.field === 'memberCount' ? 'active' : ''}`} />
                                            </div>
                                            <div className="packs-th packs-th-actions">
                                                <span>Akcje</span>
                                            </div>
                                        </div>

                                        <div className="packs-table-body">
                                            {sortedPackages.length > 0 ? (
                                                sortedPackages.map((pkg) => (
                                                    <React.Fragment key={pkg.id}>
                                                        <div
                                                            className={`packs-table-row ${hoveredPackageId === pkg.id ? 'hovered' : ''} ${expandedPackageId === pkg.id ? 'expanded' : ''}`}
                                                            onMouseEnter={() => setHoveredPackageId(pkg.id)}
                                                            onMouseLeave={() => setHoveredPackageId(null)}
                                                            onClick={() => setExpandedPackageId(expandedPackageId === pkg.id ? null : pkg.id)}
                                                        >
                                                            <div className="packs-td packs-td-id">
                                                                {pkg.id}
                                                            </div>
                                                            <div className="packs-td packs-td-name">
                                                                <span className="packs-name-text">{pkg.name}</span>
                                                            </div>
                                                            <div className="packs-td packs-td-founder">
                                                                {pkg.founder}
                                                            </div>
                                                            <div className="packs-td packs-td-members">
                                                                {pkg.memberCount}
                                                            </div>
                                                            <div className="packs-td packs-td-actions">
                                                                {hoveredPackageId === pkg.id && (
                                                                    <button
                                                                        className="packs-action-btn"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setSelectedPackageForDetails(pkg);
                                                                        }}
                                                                    >
                                                                        •••
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {expandedPackageId === pkg.id && pkg.users && (
                                                            pkg.users.map((user, userIndex) => (
                                                                <div
                                                                    key={`user-${pkg.id}-${user.id}`}
                                                                    className={`packs-user-row ${userIndex === pkg.users.length - 1 ? 'last-user' : ''}`}
                                                                >
                                                                    <div className="packs-user-td packs-user-spacer"></div>
                                                                    <div className="packs-user-td packs-user-number">
                                                                        {user.id}
                                                                    </div>
                                                                    <div className="packs-user-td packs-user-avatar">
                                                                        <div className="packs-avatar-circle">
                                                                            <span className="packs-avatar-placeholder">
                                                                                {user.username.charAt(0).toUpperCase()}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="packs-user-td packs-user-name">
                                                                        <span className={user.isFounder ? 'founder-name' : ''}>
                                                                            {user.username}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        )}
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <div className="packs-empty-row">
                                                    <p>Brak paczek dla tego użytkownika</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'stats' && (
                        <div className="tab-content stats-tab">
                            <div className="stats-grid">
                                <div className="stats-card stats-card-peach">
                                    <div className="stats-metric">
                                        <img className="stats-icon-image" src={peopleIcon} alt="" />
                                        <div className="stats-value">26</div>
                                    </div>
                                    <div className="stats-label">Założone paczki</div>
                                </div>
                                <div className="stats-card stats-card-teal">
                                    <div className="stats-metric">
                                        <img className="stats-icon-image" src={profileAddIcon} alt="" />
                                        <div className="stats-value">3</div>
                                    </div>
                                    <div className="stats-label">Dołączenia do paczek</div>
                                </div>
                                <div className="stats-card stats-card-teal">
                                    <div className="stats-metric">
                                        <img className="stats-icon-image" src={profileTickIcon} alt="" />
                                        <div className="stats-value">3</div>
                                    </div>
                                    <div className="stats-label">Potwierdzone obecności</div>
                                </div>
                                <div className="stats-card stats-card-peach">
                                    <div className="stats-metric">
                                        <img className="stats-icon-image" src={magicStarIcon} alt="" />
                                        <div className="stats-value">26</div>
                                    </div>
                                    <div className="stats-label">Pozytywne oceny od innych</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'reports' && (
                        <div className="tab-content reports-tab">
                            <div className="user-detail-table-scope table-container">
                                <div className="table">
                                    <div className="table-header">
                                        <Row columns={reportsHeaders} columnWidths={reportsColumnWidths} />
                                    </div>
                                    <div className="table-body">
                                        {reportsData.map((report) => (
                                            <React.Fragment key={report.id}>
                                                <Row
                                                    columns={renderReportRow(report)}
                                                    columnWidths={reportsColumnWidths}
                                                />
                                                {expandedReportId === report.id && (
                                                    <Row
                                                        rowClass="report-details-row"
                                                        columns={[
                                                            <div
                                                                key={`report-details-${report.id}`}
                                                                className="report-details-panel"
                                                                id={`report-details-${report.id}`}
                                                            >
                                                                <div className="report-details-grid">
                                                                    <div className="report-message-card">
                                                                        <div className="report-card-title">Oznaczona wiadomość</div>
                                                                        <div className="report-message-user">
                                                                            <div className="report-avatar">
                                                                                {report.reportedMessage.author.charAt(0).toUpperCase()}
                                                                            </div>
                                                                            <span className="report-user-name">{report.reportedMessage.author}</span>
                                                                        </div>
                                                                        <p className="report-message-text">{report.reportedMessage.content}</p>
                                                                    </div>
                                                                    <div className="report-message-card">
                                                                        <div className="report-card-title">Wiadomość zgłaszającego</div>
                                                                        <p className="report-message-text">{report.reporterMessage || '-'}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="report-details-actions">
                                                                    <button className="report-reject-btn" type="button">
                                                                        Odrzuć zgłoszenie
                                                                    </button>
                                                                </div>
                                                            </div>,
                                                            '',
                                                            '',
                                                            '',
                                                            '',
                                                        ]}
                                                        columnWidths={reportsColumnWidths}
                                                    />
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="user-detail-footer">
                    <div className="footer-buttons">
                        <button className="action-btn outline danger" type="button">
                            <TrashIcon className="btn-icon" />
                            <span>Usuń</span>
                        </button>
                        <button className="action-btn outline" type="button">
                            {selectedUser.status === 'blocked' ? (
                                <>
                                    <UnlockIcon className="btn-icon" />
                                    <span>Odblokuj</span>
                                </>
                            ) : (
                                <>
                                    <LockIcon className="btn-icon" />
                                    <span>Zablokuj</span>
                                </>
                            )}
                        </button>
                        <button className="action-btn filled" type="button" onClick={handleEdit}>
                            <EditIcon className="btn-icon" />
                            <span>Edytuj</span>
                        </button>
                    </div>
                </div>
            </div>

            {selectedPackageForDetails && (
                <div className="package-modal-overlay" onClick={() => setSelectedPackageForDetails(null)}>
                    <div className="package-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="package-modal-header">
                            <button
                                className="package-modal-close"
                                onClick={() => setSelectedPackageForDetails(null)}
                            >
                                <CloseIcon />
                            </button>
                        </div>

                        <div className="package-modal-title-section">
                            <div className="package-modal-title-info">
                                <h2 className="package-modal-title">{selectedPackageForDetails.name}</h2>
                                <span className="package-modal-date">
                                    {new Date(selectedPackageForDetails.event.date).toLocaleDateString('pl-PL', {
                                        weekday: 'short',
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric',
                                    })}
                                </span>
                            </div>
                        </div>

                        <div className="package-modal-section">
                            <h3 className="package-modal-section-title">Wydarzenie</h3>
                            <div className="package-modal-event-card">
                                <div className="package-event-image">
                                    <div className="package-event-image-placeholder">
                                        <span>{selectedPackageForDetails.event.name.charAt(0)}</span>
                                    </div>
                                </div>
                                <div className="package-event-details">
                                    <div className="package-event-info">
                                        <span className="package-event-name">{selectedPackageForDetails.event.name}</span>
                                        <span className="package-event-location">{selectedPackageForDetails.event.location}</span>
                                    </div>
                                    <div className="package-event-datetime">
                                        <span className="package-event-date-small">
                                            {new Date(selectedPackageForDetails.event.date).toLocaleDateString('pl-PL', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric',
                                            })}
                                        </span>
                                        <span className="package-event-time">{selectedPackageForDetails.event.time}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="package-modal-section">
                            <h3 className="package-modal-section-title">Data i godzina wyjścia</h3>
                            <div className="package-modal-datetime-row">
                                <div className="package-datetime-item">
                                    <CalendarIcon className="package-datetime-icon" />
                                    <span className="package-datetime-value">
                                        {new Date(selectedPackageForDetails.event.date).toLocaleDateString('pl-PL')}
                                    </span>
                                </div>
                                <div className="package-datetime-item">
                                    <ClockIcon className="package-datetime-icon" />
                                    <span className="package-datetime-value">dowolna</span>
                                </div>
                            </div>
                        </div>

                        <div className="package-modal-section package-founder-section">
                            <h3 className="package-modal-section-title">Założyciel paczki</h3>
                            <div className="package-founder-row">
                                <div className="package-founder-avatar">
                                    <span>{selectedPackageForDetails.founder.charAt(0).toUpperCase()}</span>
                                </div>
                                <div className="package-founder-info">
                                    <span className="package-founder-name">{selectedPackageForDetails.founder}</span>
                                </div>
                            </div>
                        </div>

                        <div className="package-modal-section">
                            <h3 className="package-modal-section-title">Opis paczki</h3>
                            <div className="package-description-box">
                                <p>{selectedPackageForDetails.description}</p>
                            </div>
                        </div>

                        <div className="package-modal-section">
                            <h3 className="package-modal-section-title">Paczka</h3>
                            <div className="package-members-grid">
                                {selectedPackageForDetails.users.map((user) => (
                                    <div key={user.id} className="package-member-item">
                                        <div className="package-member-avatar">
                                            <span>{user.username.charAt(0).toUpperCase()}</span>
                                        </div>
                                        <span className="package-member-name">{user.username}</span>
                                    </div>
                                ))}
                                {selectedPackageForDetails.users.length < 8 && (
                                    Array(8 - selectedPackageForDetails.users.length).fill(null).map((_, index) => (
                                        <div key={`empty-${index}`} className="package-member-item package-member-empty">
                                            <div className="package-member-avatar empty-slot">
                                                <span>+</span>
                                            </div>
                                            <span className="package-member-name">Pusty slot</span>
                                        </div>
                                    ))
                                )}
                            </div>
                            <button className="package-show-all-btn">Pokaż wszystkich w paczce</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default UserDetailPanel;
